import * as React from 'react';
import { styled } from '@linaria/react';

import Demo, { DemoSliderControl } from '@/components/Demo';
import ClientOnlySnippet from '@/components/CodeSnippet/ClientOnlySnippet';

function HueRotate({}) {
  return (
    <Demo
      initialValues={{
        rotation: 0,
      }}
      controlPosition="bottom"
      outputWrapper={null}
      customGrid={{
        gridTemplateColumns: '1fr',
      }}
      controls={[
        <DemoSliderControl
          key="rotation"
          id="rotation"
          label="Hue rotation"
          min={0}
          max={360}
          previewRenderer={(val) => `${val}deg`}
          wrapperStyle={{
            maxWidth: 400,
            width: '100%',
            marginInline: 'auto',
          }}
        />,
      ]}
    >
      {({ rotation }) => {
        return (
          <Wrapper>
            <Mascot
              alt="My 3D mascot making a puzzled face. Dragging the slider causes him to become unnatural shades of green and pink."
              src="/images/newsletter/joy-of-react-mascot.png"
              loading="lazy"
              style={{
                filter: `hue-rotate(${rotation}deg)`,
              }}
            />
            <CodeWrapper>
              <ClientOnlySnippet
                omitCopyButton
                lockedToColorMode="dark"
                lang="css"
                code={`\
.atom-fella {
  filter: hue-rotate(${rotation}deg);
}\
`}
              />
            </CodeWrapper>
          </Wrapper>
        );
      }}
    </Demo>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  border: 1px solid var(--color-content-outline);
  border-radius: 8px;
`;

const Mascot = styled.img`
  display: block;
  width: 300px;
  height: 262.5px;
  margin-bottom: -80px;
`;

const CodeWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 360px;
  min-height: 8rem;
  border: 1px solid var(--color-gray-200);
  background: var(--color-background);
  align-self: center;
  border-radius: 4px;

  @media (max-width: 38rem) {
  }
`;

export default HueRotate;
